import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/axios';

export interface RoleOption {
  id: string;
  slug: string;
  name: string;
}

export const ROLE_OPTIONS_QUERY_KEY = ['roles', 'options'] as const;

/**
 * Rótulos dos perfis vindos da API.
 *
 * Substitui o mapa estático em `roleLabels.ts`: um perfil criado pelo
 * Administrador depois do deploy precisa aparecer com o nome certo em
 * dropdowns e badges, sem alteração de código.
 */
export function useRoleLabels() {
  const { data, isLoading } = useQuery({
    queryKey: ROLE_OPTIONS_QUERY_KEY,
    queryFn: async () => {
      const { data } = await api.get<{ data: RoleOption[] }>('/roles/options');
      return data.data;
    },
    staleTime: 5 * 60_000,
  });

  const options = data ?? [];
  const bySlug = new Map(options.map((r) => [r.slug, r.name]));

  return {
    options,
    isLoading,
    /** Nome do perfil; cai no próprio slug se ainda não carregou ou sumiu. */
    labelFor: (slug: string) => bySlug.get(slug) ?? slug,
  };
}
